module.exports = __webpack_public_path__ + "media/logos/dark_blob-5d44078c.png";